// src/hooks/useRoleColors.js
import { useTheme } from '@mui/material/styles';

const fallback = {
  accent: '#1976d2',
  accentLight: '#42a5f5',
  accentDark: '#0d47a1',
  accentGradient: 'linear-gradient(135deg, #1976d2 0%, #1565c0 100%)',
  accentGradientHover: 'linear-gradient(135deg, #1565c0 0%, #0d47a1 100%)',
  softBg: 'rgba(25, 118, 210, 0.08)',
  softBgHover: 'rgba(25, 118, 210, 0.15)',
  softBgStrong: 'rgba(25, 118, 210, 0.3)',
  contrast: '#ffffff',
  outline: 'rgba(25, 118, 210, 0.4)',
  badge: '#1976d2',
};

const useRoleColors = () => {
  const theme = useTheme();
  const roleColors = theme.custom?.roleColors || {};

  return {
    accent: roleColors.primary || fallback.accent,
    accentLight: roleColors.primaryLight || fallback.accentLight,
    accentDark: roleColors.primaryDark || fallback.accentDark,
    accentGradient: roleColors.gradient || fallback.accentGradient,
    accentGradientHover: roleColors.gradientHover || fallback.accentGradientHover,
    softBg: roleColors.softBg || fallback.softBg,
    softBgHover: roleColors.softBgHover || fallback.softBgHover,
    softBgStrong: roleColors.softBgStrong || fallback.softBgStrong,
    contrast: roleColors.contrastText || fallback.contrast,
    outline: roleColors.outline || fallback.outline,
    badge: roleColors.badge || fallback.badge,
  };
};

export default useRoleColors;

